import React from 'react';

import { OddsFormat, useAuthUserSettings, useUpdateUserSettings } from '@/hooks/use-auth-user-settings';
import { logger } from '@/utils/logging';

import { CustomSwitch } from './CustomSwitch';

const LOG_TAG = '[Classic Mode Switch]';

export const ClassicModeSwitch = () => {
    const { data } = useAuthUserSettings();
    const { mutateAsync: updateUserSettings } = useUpdateUserSettings();
    const classicModeEnabled = data?.odds_format === OddsFormat.AMERICAN; // Classic Mode uses American odds

    const handleOnPress = async () => {
        const newEnabledState = !classicModeEnabled;
        const oddsFormat = newEnabledState ? OddsFormat.AMERICAN : OddsFormat.DECIMAL;
        try {
            await updateUserSettings({ odds_format: oddsFormat });
        } catch (error: unknown) {
            logger.error(LOG_TAG, 'Error updating user settings', error);
        }
    };

    return <CustomSwitch val={classicModeEnabled} handleOnPress={handleOnPress} />;
};
